// Home component serving as the main landing page
import React from 'react';
import '../App.css';

const Home = () => {
    return (
        <div className="home-page-container">
            <div className="news-section">
                <h2><strong>News & Updates:</strong></h2>
                <h4>New Feature!</h4>
                <p>We are excited to introduce you to <a href="/travellists"><strong>Travel Lists</strong></a>! A new feature where you can plan your outfits for upcoming trips effortlessly by adding and organizing clothes specific to each journey.</p>
                <h4>Update to our User Agreement</h4>
                <p>There are some new terms included in our <a href="/user-agreement"><strong>User Agreement</strong></a>, feel free to check them out and <a href="/contact-us">contact us</a> in case of any concerns or questions!</p>
            </div>
            
            <div className="welcome-section">
                <h1><strong>Welcome to your Digital Wardrobe</strong></h1>
                <p>The map to find the treasure hidden inside your wardrobe. Enjoy the adventure!</p>
            </div>
        </div>
    );
};

export default Home;